// extracted by mini-css-extract-plugin
export default {"listWrap":"BodyDropdownSetting_listWrap__xYSEk","option":"BodyDropdownSetting_option__WO-f1","button":"BodyDropdownSetting_button__huoOz"};